export default {
  namespaced: true,
  state: {
    snackbar: {
      show: false,
      text: '',
      color: '',
      timeout: -1,
      multiline: false,
    },
  },
  getters: {
    snackbar: (state) => {
      return state.snackbar;
    },
  },
  mutations: {
    show_snackbar(state, payload) {
      state.snackbar.show = true;
      state.snackbar.text = payload.text;
      state.snackbar.color = payload.color;
      state.snackbar.timeout = payload.timeout;
      state.snackbar.multiline = payload.multiline;
    },
    hide_snackbar(state) {
      state.snackbar.show = false;
      state.snackbar.text = '';
    },
  },
};
